<template>
    <v-container fluid>
        <v-row >
            <v-col>
                <v-card class="dashboard-card">
                    <v-card-title>
                        <h2>Dashboard</h2>
                    </v-card-title>
                    <v-card-text class="text--primary">
                        <div>
                            <missing-samples-container></missing-samples-container>
                        </div>
                        <div>
                            <batch-container></batch-container>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

    import BatchContainer from '../Batches/BatchContainer'
    import MissingSamplesContainer from '../MissingSamples/MissingSamplesContainer'

    export default {
        name: "Dashboard",
        components: {
            MissingSamplesContainer,
            BatchContainer
        },
        data() {
            return {

            }
        }

    }
</script>

<style scoped>
    .dashboard-card {
        min-width: 1100px;
    }
</style>